import React from 'react';
import { IProps as IBlockProps } from './ImageCarouselBlock.interface';
import { ImageCarouselBlock } from './ImageCarouselBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities'

export interface IBlockInputProps {
    heading?: string
    summary?: string
    items: {
        link?: Record<string, any>;
        image: Record<string, any>;
    }[]
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        heading,
        summary,
        items,
        tileLayout,
        isGlobalHeader,
        ...rest // Capture all other props for BlockWrapper
    } = input;

    return {
        title: heading,
        content: summary,
        items: items.map(item => {
            const { link, image } = item;
            return ({
                image: image ? translation.mapImageProps(image) : undefined,
                button: link ? translation.mapAnchorProps(link) : undefined,
            })
        }),
        ...rest,
    };
};

const ImageCarouselBlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={ImageCarouselBlock}
        mapProps={mapInputToProps}
    />
);

export default ImageCarouselBlockTranslation;
